export default __webpack_public_path__ + "static/media/mobapp.958a3b55.png";